import * as Mui from "@mui/material";
import { useMemo } from "react";
import { Link,useLocation, useParams  } from 'react-router-dom';
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import { GenericTitleHeader } from "../../common/GenericTitleHeader";
import TransferRequestType from "../../../types/TransferRequestType";

interface Props {
  transferRequest: TransferRequestType | undefined;
}

export const DeliveryDetailsTitleNavigation = (props: Props) => {
  const t = useOperationTranslation();
  const location = useLocation();
  const { id } = useParams();
  
  let status = (params: string | undefined) => {
    if (params === undefined) return "";
    switch (params) {
      case "REJECTED":
        return t("transferReason.autocomplete.rejected");

      case "APPROVED":
        return t("transferReason.autocomplete.approved");

      case "TO_BE_APPROVED":
        return t("transferReason.autocomplete.toBeApproved");

      case "CREATED":
        return t("transferReason.autocomplete.created");

      case "APPROVED_WITH_DDT":
        return t("transferReason.autocomplete.approvedWithDdt");
      case "TRANSFER_COMPLETED":
        return t("transferReason.autocomplete.transferCompleted");
      case "DUPLICATE_CANCELLED_BY_SYSTEM":
        return t("transferReason.autocomplete.duplicateCancelledBySystem");
      default:
        return "";
    }
  };
  
  const basePath = useMemo(() => `/operation/transfer/deliveryNotes/details/${id}`, []);
  return (
    <>
      <GenericTitleHeader 
        firstTitleHeaderBlue={t("deliveryNote.deliveryDetails.titleFirst")}
        secondTitleHeaderViolet={t("deliveryNote.deliveryDetails.titleSecond")}
      >
        <Mui.Grid container spacing={2}>
          <Mui.Grid item xs="auto" display="flex" gap={2} alignItems="center">
            <Mui.Typography variant="h6">
              {t("deliveryNote.deliveryDetails.title.details.numeroRichiesta")}
            </Mui.Typography>
            <Mui.Typography>{props.transferRequest?.number}</Mui.Typography>
          </Mui.Grid>
          
          <Mui.Grid item xs="auto" display="flex" gap={2} alignItems="center">
            <Mui.Typography variant="h6">
              {t("deliveryNote.deliveryDetails.title.details.numeroDDT")}
            </Mui.Typography>
            <Mui.Typography>{props.transferRequest?.deliveryNoteNumber}</Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" display="flex" gap={2} alignItems="center">
            <Mui.Typography variant="h6">
              {t("deliveryNote.deliveryDetails.title.details.stato")}
            </Mui.Typography>
            <Mui.Typography>{status(props.transferRequest?.status)}</Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
      </GenericTitleHeader>

    {/* Tabs */}
    <Mui.Box component={"div"} pl={2} pr={2}  >
        <Mui.Tabs
        sx={{boxShadow: '0px -4px 0px rgba(151, 151, 151, 0.2) inset',  }}
          TabIndicatorProps={{
            sx: {
              height: "5px",
              backgroundColor: "rgba(200, 1, 125, 1)",
              

            },
          }}
          value={location.pathname}
          aria-label="basic tabs example"
        >
          <Mui.Tab
          
            to={basePath}
            component={Link}
            label={
              <Mui.Box>
                <Mui.Typography >
                {t("deliveryNote.deliveryDetails.tab.transferRequest.tabTitle")}
                </Mui.Typography>
              </Mui.Box>
            }
            value={basePath}
          ></Mui.Tab>
          <Mui.Tab
            to={`${basePath}/carsegmentinfo`}
            component={Link}
            label={
              <div>
                <Mui.Typography >
                {t("deliveryNote.deliveryDetails.tab.carSegmentInfo.tabTitle")}
                </Mui.Typography>
              </div>
            }
            value={`${basePath}/carsegmentinfo`}
          ></Mui.Tab>
          <Mui.Tab
            to={`${basePath}/deliverynotesinfo`}
            component={Link}
            label={
              <div>
                <Mui.Typography >
                {t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.tabTitle")}
                </Mui.Typography>
              </div>
            }
            value={`${basePath}/deliverynotesinfo`}
          ></Mui.Tab>
          <Mui.Tab
            to={`${basePath}/drivers`}
            component={Link}
            label={
              <div>
                <Mui.Typography >
                {t("deliveryNote.deliveryDetails.tab.drivers.tabTitle")}
                </Mui.Typography>
              </div>
            }
            value={`${basePath}/drivers`}
          ></Mui.Tab>
        </Mui.Tabs>
      </Mui.Box>    
      </>
  )
}
